import MicroModal from 'micromodal';

(function () {

  if (!document.body.classList.contains('area-map-page')) return this;

  MicroModal.init();

})();
